import React from "react";

import Tensorflow from "./components/tensorflowsigner/Tensorflow";

function App() {
  return (
    <div>
      <Tensorflow />
    </div>
  );
}

export default App;
